import { Typography, Button } from "@mui/material"
import { Dialog, Stack } from "src/shared/components"
import { Save as SaveIcon } from "@mui/icons-material"
import { useTransition, ReactNode } from "react"
import { useForm, UseFormReturn } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

interface CreateEntityDialogProps {
  open: boolean
  onClose: () => void
  title: string
  schema: yup.AnyObjectSchema
  defaultValues: any
  onSave: (data: any) => void | Promise<void>
  isLoading?: boolean
  children: (form: UseFormReturn<any>) => ReactNode
}

function CreateEntityDialog({
  open,
  onClose,
  title,
  schema,
  defaultValues,
  onSave,
  isLoading,
  children
}: CreateEntityDialogProps) {
  const [isPending, startTransition] = useTransition()

  const form = useForm({
    resolver: yupResolver(schema),
    values: defaultValues,
    defaultValues
  })
  console.log("form-sss", form)
  const handleSave = () => {
    form.handleSubmit((data) => {
      console.log("data", data)
      startTransition(async () => {
        try {
          await onSave(data)
          form.reset()
          // onClose()
        } catch (error) {
          console.error("Error saving entity:", error)
        }
      })
    })()
  }

  const handleClose = () => {
    form.reset()
    onClose()
  }

  const laoding = isLoading || isPending
  return (
    <Dialog fullWidth maxWidth="sm" open={open} toggleDialog={handleClose}>
      <Stack position="relative" height={"100%"} spacing={2} p={2}>
        <Typography variant="h3">{title}</Typography>

        {children(form)}

        <Stack direction="row" spacing={2} mt={3}>
          <Button variant="outlined" onClick={handleClose} disabled={laoding} sx={{ minWidth: 120 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleSave}
            disabled={laoding}
            sx={{ minWidth: 120 }}
          >
            {laoding ? "Saving..." : "Save"}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  )
}

export default CreateEntityDialog
